<template>
  <div v-if="cases && cases.length > 0">
    <div
      class="report-viewer page-break report-landscape"
      v-for="(cvr, idx) in cover"
      :key="`cover${idx}`"
    >
      <div class="report-viewer-content">
        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th
                  rowspan="5"
                  colspan="4"
                  class="text-center"
                  style="width: 10px !important"
                >
                  <img src="@/assets/jkr.jpg" class="w-50" />
                  <p class="mb-0 mt-2">JKR MALAYSIA</p>
                </th>
                <th rowspan="5" colspan="13" class="text-center text-wrap">
                  PROSEDUR PENYELIAAN KERJA RUTIN
                </th>
                <td
                  colspan="2"
                  class="border-transparent-right pr-0 align-middle"
                >
                  No. Rujukan Dokumen
                </td>
                <td class="align-middle text-nowrap">
                  :&nbsp;&nbsp;JKR.PK(SJ).01.04.02-12
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-transparent-right pr-0">
                  No. Keluaran
                </td>
                <td>:&nbsp;&nbsp;00</td>
              </tr>
              <tr>
                <td colspan="2" class="border-transparent-right pr-0">
                  No. Pindaan
                </td>
                <td>:&nbsp;&nbsp;01</td>
              </tr>
              <tr>
                <td colspan="2" class="border-transparent-right pr-0">
                  Tarikh
                </td>
                <td>:&nbsp;&nbsp;Disember 2018</td>
              </tr>
              <tr>
                <td colspan="2" class="border-transparent-right pr-0">
                  Muka Surat
                </td>
                <td>:&nbsp;&nbsp;{{ `${idx + 1}/${cover.length}` }}</td>
              </tr>
              <tr>
                <th
                  colspan="20"
                  class="
                    h6
                    mb-0
                    py-0
                    font-weight-bold
                    text-center
                    border-transparent-top border-transparent-bottom
                  "
                ></th>
              </tr>
              <tr>
                <th
                  colspan="20"
                  class="
                    text-center
                    border-transparent-top border-transparent-bottom
                    text-uppercase
                  "
                >
                  LAPORAN LAWATAN INSPEKTOR RUTIN
                </th>
              </tr>
              <tr>
                <th
                  colspan="20"
                  class="
                    border-transparent-top
                    font-weight-medium
                    text-uppercase
                  "
                >
                  TAHUN/BULAN/NO. MINGGU:
                  <!-- {{ moment(Date.now()).format("MMMM YYYY") }} -->
                </th>
              </tr>
              <tr class="table-active">
                <th
                  class="text-center line-height-1"
                  rowspan="2"
                  style="width: 1%"
                >
                  TARIKH<br />PERIKSA
                </th>
                <th colspan="3" rowspan="2" class="text-nowrap">
                  NO &amp; NAMA LALUAN
                </th>
                <th colspan="4" class="text-center text-nowrap">NO SEKSYEN</th>
                <th colspan="3" rowspan="2" class="text-center text-nowrap">
                  KEROSAKAN DIKENALPASTI
                </th>
                <th colspan="5" class="text-center">KATEGORI</th>
                <th rowspan="2" class="text-center line-height-1">
                  LOKASI<br />KEROSAKAN
                </th>
                <th rowspan="2" class="text-center line-height-1">
                  TINDAKAN<br />DIAMBIL
                </th>
                <th rowspan="2" class="text-center line-height-1">
                  TARIKH<br />TINDAKAN<br />DIAMBIL
                </th>
                <th rowspan="2" class="text-center">CATATAN</th>
              </tr>
              <tr class="table-active">
                <th colspan="2" class="text-center">DARI</th>
                <th colspan="2" class="text-center">HINGGA</th>
                <th>R</th>
                <th>BP</th>
                <th>BBP</th>
                <th>K</th>
                <th>AB</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in cvr" :key="c._id">
                <td class="text-center text-nowrap" style="width: 1%">
                  {{ helper.formatDate(c.timestamp, true) }}
                </td>
                <td class="text-uppercase" colspan="3">
                  {{ c.road ? c.road.name : "" }}
                </td>
                <td colspan="2"></td>
                <td colspan="2"></td>
                <td colspan="3">
                  {{ c.caption }}
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Rutin'">/</span>
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Berkala_Pavemen'">
                    /
                  </span>
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Berkala_Bukan_Pavemen'">
                    /
                  </span>
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Kecemasan'">/</span>
                </td>
                <td class="text-center">
                  <span class="h4" v-if="c.category == 'Agensi_Berkenaan'">
                    /
                  </span>
                </td>
                <td></td>
                <td>{{ c.afterCaption }}</td>
                <td class="text-center text-nowrap">
                  {{
                    c.solveDate
                      ? helper.formatDate(c.solveDate * 1000, true)
                      : ""
                  }}
                </td>
                <td>{{ c.remarks }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td
                  colspan="2"
                  class="
                    border-transparent-left
                    border-transparent-right
                    border-transparent-top
                    px-0
                  "
                >
                  <br />
                  <br />
                  <br />
                  <hr class="border-dark mb-0" />
                  <small>(Syarikat Konsesi/Kontraktor)</small>
                  <br />
                  <br />
                  <p class="mb-0">
                    Tarikh: {{ helper.formatDate(Date.now(), true) }}
                  </p>
                </td>
                <td
                  colspan="15"
                  class="
                    border-transparent-left
                    border-transparent-right
                    border-transparent-top
                    px-0
                  "
                ></td>
                <td
                  colspan="3"
                  class="
                    border-transparent-left
                    border-transparent-right
                    border-transparent-top
                    px-0
                  "
                >
                  <div>
                    <p class="mb-0">Nota:</p>
                    <p class="mb-0">Disediakan oleh:</p>
                    <p class="mb-0">R: Rutin</p>
                    <p class="mb-0">BP: Berkala Pavemen</p>
                    <p class="mb-0">BBP: Berkala Bukan Pavemen</p>
                    <p class="mb-0">K: Kecemasan</p>
                    <p class="mb-0">AB: Agensi Berkenaan</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="10" class="border-transparent px-0 pb-0">
                  &copy; HAKCIPTA JKR MALAYSIA
                </td>
                <td
                  colspan="10"
                  class="border-transparent text-right px-0 pb-0"
                >
                  <p
                    class="
                      border border-dark
                      pl-3
                      py-1
                      pr-5
                      mb-0
                      d-inline-block
                    "
                  >
                    DOKUMEN TERKAWAL
                  </p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helper from "@/helper";
import Moment from "moment";

export default {
  props: [
    "cases",
    "title",
    "formName",
    "reportDistrict",
    "reportDate",
    "appendixNumber",
    "reportHeader",
  ],
  data() {
    return {
      cover: [],
      helper: Helper,
      moment: Moment,
    };
  },
  watch: {
    cases: {
      handler() {
        if (this.cases.length > 0) {
          this.cover = [];

          const maxRow = 13;

          JSON.parse(JSON.stringify(this.cases)).forEach((c) => {
            if (
              this.cover[this.cover.length - 1] &&
              this.cover[this.cover.length - 1].length < maxRow
            ) {
              this.cover[this.cover.length - 1].push(c);
            } else {
              this.cover.push([c]);
            }
          });

          this.cover.forEach((c) => {
            if (c.length < maxRow) {
              const rowToAdd = maxRow - c.length;

              for (let i = 0; i < rowToAdd; i++) {
                c.push({});
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@media print {
  @import "@/assets/css/print.scss";

  html,
  body,
  table,
  tr,
  th,
  td {
    font-size: 7pt !important;
  }

  .report-landscape {
    width: 210mm !important;
    height: 293mm !important;
    margin: 0 !important;
    position: relative;
    overflow: hidden !important;

    .report-viewer-content {
      overflow: hidden;
      width: 293mm !important;
      height: 210mm !important;
      transform: rotate(-90deg) translateX(-41.5mm) translateY(-41mm);
    }
  }
}
</style>